export class DialogBase {
  dialog = null;
  _isShown = false;

  constructor(options) {
    this.dialog = document.getElementById(options.dialogId);
    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  close() {
    this.dialog.close();
    document.body.style.overflow = 'auto';
    this._isShown = false;
  }

  show() {
    this.dialog.showModal();
    document.activeElement.blur();
    document.body.style.overflow = 'hidden';
    const wasHidden = !this._isShown;
    this._isShown = true;
    return wasHidden && this._isShown;
  }

  init() {
    this.dialog.addEventListener('click', event => {
      const rect = this.dialog.getBoundingClientRect();
      const isInDialog =
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width;
      if (!isInDialog) {
        this.close();
      }
    });
  }
}
